module.exports = __webpack_public_path__ + "media/images/landkit/devices/macbook-ae61a0eafb1061bf55966f40ac14cc02.svg";